import './index.css'

const TradingApps = () => {
  return (
      <section className="trading-apps">
          <div className="trading-content">
              <h2>Trading Applications for All Platforms</h2>
              <p>
                  Click the button below to download Windows, Mac, or iPhone Apps.
                  <br />
                  You can also access the trading portal directly without downloading any app using the Web App.
              </p>

              <div className="download-buttons">
                  <a href="https://vtrade.pk/" target="_blank" rel="noopener noreferrer" className="store-button">
                      <i className="fab fa-windows"></i>
                      <div>
                          <span>Download on the</span>
                          <strong>Windows</strong>
                      </div>
                  </a>
                  <a href="https://vtrade.pk/" target="_blank" rel="noopener noreferrer" className="store-button">
                      <i className="fab fa-android"></i>
                      <div>
                          <span>Download on the</span>
                          <strong>Android</strong>
                      </div>
                  </a>
                  <a href="https://vtrade.pk/"target="_blank" rel="noopener noreferrer"  className="store-button">
                      <i className="fab fa-app-store-ios"></i>
                      <div>
                          <span>Download on the</span>
                          <strong>IOS</strong>
                      </div>
                  </a>
              </div>

              <a href="https://www.aof.com.pk/member/login.php" target="_blank" rel="noopener noreferrer" className="web-login-btn">
                  Login on Web Browser
              </a>
          </div>
      </section>
  );
};

export default TradingApps;
